(function($) {
  $(document).ready(function() {

    if ($('#map-holder').length > 0 ){
      var geocoder = new google.maps.Geocoder();
      var mapAddress = $('.map-info').data('map-address');
      var mapZoom = $('.map-info').data('map-zoom');
      var mapPin = $('.map-info').data('map-pin');
      var ctPhone = $('.map-info').data('contact-phone');
      var ctEmail = $('.map-info').data('contact-email');
      var mapId = 'map-holder';

      geocoder.geocode( { "address": mapAddress }, function(results, status) {
          if (status == google.maps.GeocoderStatus.OK && results.length > 0) {
              var location = results[0].geometry.location,
                  lati      = location.lat(),
                  lngt      = location.lng();
            initiMap(lati, lngt, mapZoom, mapId)
          } 
      });


      function initiMap(lati, lngt, mapZoom, mapId) {
        var latlng = new google.maps.LatLng(lati, lngt);
        var mapOptions = {
          center: latlng,
          zoom: mapZoom,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          styles: 
          [
            {
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#f5f5f5"
                }
              ]
            },
            {
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#616161"
                }
              ]
            },
            {
              "elementType": "labels.text.stroke",
              "stylers": [
                {
                  "color": "#f5f5f5"
                }
              ]
            },
            {
              "featureType": "administrative.land_parcel",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#bdbdbd"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#eeeeee"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#757575"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#e5e5e5"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#ffffff"
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#757575"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#dadada"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#616161"
                }
              ]
            },
            {
              "featureType": "road.local",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            },
            {
              "featureType": "transit.line",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#e5e5e5"
                }
              ]
            },
            {
              "featureType": "transit.station",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#eeeeee"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#c9c9c9"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            }
          ]
        };
        var map = new google.maps.Map(document.getElementById(mapId), mapOptions);
      
        var vegepodMarker = new google.maps.Marker({
          position: {lat: lati, lng: lngt},
          map: map,
          icon: mapPin
        });

        var contentString = '<div id="map-info-content"><div class="map-info-container"><div class="map-info-address"><label for="">Address</label><p>'+mapAddress+'</p></div><div class="map-info-contact"><div class="map-info-phone"><label for="">Phone</label><a href="tel:'+ctPhone+'">'+ctPhone+'</a></div><div class="map-info-email"><label for="">Email</label><a href="mailto:'+ctEmail+'">'+ctEmail+'</a></div></div></div></div>';

        var infowindow = new google.maps.InfoWindow({
          disableAutoPan: false,
          content: contentString,
          pixelOffset: new google.maps.Size(0, 350)
        });

        vegepodMarker.addListener('click', function() {
          infowindow.open(map, vegepodMarker);
        });

        // open marker on load
        google.maps.event.trigger(vegepodMarker,'click');
      }
    }
    
  });

  function closeInfoWindow(){
    if($(window).width() < 801){
      $('button.gm-ui-hover-effect').click();
    }
  }

  $(window).resize(closeInfoWindow);

  $(window).on('load', function () {
    closeInfoWindow();
  });

})(jQuery);